import '/assets/styles/partials/slider.scss';

import loadable from '@loadable/component';
import SliderPlaceholder from '@wearetla/tla-essentials-tools/partials/slider/slider-placeholder';
import { useMemo } from 'react';

const LazySlider = loadable(() => import('@wearetla/tla-essentials-tools/partials/slider/slider'), {
	ssr: false,
});

const Slider = (rawProps) => {
	const props = useMemo(
		() => ({
			navPrevIcon: 'arrow-left-short',
			navNextIcon: 'arrow-right-short',
			...rawProps,
			params: {
				resistanceRatio: 0.9,
				watchSlidesProgress: true,
				...(rawProps.params ?? {}),
			},
		}),
		[rawProps]
	);

	return <LazySlider {...props} fallback={<SliderPlaceholder {...props} />} />;
};

export default Slider;
